import { Component, Input } from '@angular/core';
import {UntypedFormGroup, UntypedFormBuilder, AbstractControl} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'edl-modal-confirm-notes',
    templateUrl: './edl-modal-confirm-notes.component.html',
    styleUrls:   ['./edl-modal-confirm-notes.component.scss']
})
export class EdlModalConfirmNotes {
    @Input() title: string;
    @Input() message: string;
    @Input() textAreaInstructions: string;

    noteForm: UntypedFormGroup;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder) {}

    ngOnInit() {
        this.noteForm = this.formBuilder.group({
            Message: [null, []]
        });
    }
    submit() {
        let messageBox: AbstractControl = this.noteForm.get('Message');
        let message = messageBox.value;
        this.activeModal.close(message);
    }
}